import React, { useContext, useEffect, useState } from 'react';

import { useHistory, Link } from 'react-router-dom';

import MUIDataTable from "mui-datatables";
import UserContext from '../../../../navigation/context/userContext';
import { Chip, IconButton, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardList, faEdit, faEye, faListAlt, faPlay, faTrash, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import DeleteDialog from '../../../../components/DeleteDialog';


//export default class TablaProductos extends Component
export default function ModifierGroupsDataTable({modiferGoups, onDelete, isLoading})
{
    const [modifierGroupToRemove,setModifierGroupToRemove] = useState(null);
    const [openDeleteDialog,setOpenDeleteDialog] = useState(false);

    const handleOpenDialog = (modifierGroup) => {
        setModifierGroupToRemove(modifierGroup);
        setOpenDeleteDialog(true);
    }

    const columns = [
        {
            name : 'id',
            label : 'ID',
        },
        {
            name : 'name',
            label : 'Nombre',
        },
        {
            name : 'selection_type',
            label : 'Selección',
        },
        {
            name : '',
            label : 'Opciones',
            options : 
            {
                customBodyRenderLite : (dataIndex) => {
                    if(modiferGoups[dataIndex].modifiers.length > 0)
                    {
                        return modiferGoups[dataIndex].modifiers.map((value)=>
                            <Chip key={value.id} label={value.name} sx={{marginRight:2}} />
                        ) 
                    }
                    else
                    {
                        return <Typography>No hay valores</Typography>
                    }
                        
                },
                    //let id = subCategorias[dataIndex].idSubCategoria;
                filter:false
            }
        },
        {
            name : '',
            label : 'Acciones',
            options : 
            {
                customBodyRenderLite : (dataIndex) => {
                    //let id = modiferGoups[dataIndex].idSubCategoria;
                    return(
                        <div style={{display:'flex',flexDirection:'row',justifyContent:'center'}}>
                            {/*<Link 
                                to={'/products/modiferGoups/update/'+modiferGoups[dataIndex].id} 
                                //onClick={ ()=> localStorage.setItem('categoria',JSON.stringify(modiferGoups[dataIndex])) }
                                replace
                            >
                                <IconButton>
                                    <FontAwesomeIcon icon={faEdit}/>
                                </IconButton>
                            </Link>*/}

                            <Link 
                                to={'/products/modifiergroups/options/'+modiferGoups[dataIndex].id}
                                //onClick={ ()=> localStorage.setItem('categoria',JSON.stringify(modiferGoups[dataIndex])) }
                                replace
                            >
                                <IconButton color='link'>
                                    <FontAwesomeIcon icon={faEye}/>
                                </IconButton>
                            </Link>

                            <IconButton color='error' onClick={()=>handleOpenDialog(modiferGoups[dataIndex])}>
                                <FontAwesomeIcon icon={faTrashAlt}/>
                            </IconButton>
                        </div>
                    );
                },

                print : false
            }
        }
    ];


    const options = {
        filterType: 'checkbox',
        selectableRows: 'none',
      };


    return(
        <>
            <MUIDataTable
                title={"Listado de Opciones"}
                data={modiferGoups}
                columns={columns}
                options={options}
            />
            <DeleteDialog
                open={openDeleteDialog}
                title={'Eliminar Grupo de Opciones'}
                message={'¿Está seguro que desea eliminar el grupo de opciones "'+ (modifierGroupToRemove ? modifierGroupToRemove.name : '') +'"? Esta acción no se puede deshacer.'}
                isLoading={isLoading}
                onClose={ ()=> setOpenDeleteDialog(false) }
                onConfirm={ async () => {
                    await onDelete(modifierGroupToRemove.id);
                    setOpenDeleteDialog(false);
                } }
            />
        </>
    )
}